import type { AlertSeverity } from "@/types";

export default function SeverityBadge({ severity }: { severity: AlertSeverity }) {
  const map: Record<AlertSeverity, string> = {
    low: "bg-blue-50 text-blue-700",
    medium: "bg-amber-50 text-amber-700",
    high: "bg-red-50 text-red-700",
  };
  return <span className={`badge ${map[severity]}`}>{severity}</span>;
}
